import { jsx, Fragment } from 'react/jsx-runtime';
const MyEmpowerFooter = () => {
  return /* @__PURE__ */jsx(Fragment, {});
};
export { MyEmpowerFooter as default };